module.exports = "https://img1.huilianyi.com/9/avoid-print-flag-en.908d312ffd.appcore.png";